<template>
  <div :class="containerClass">
    <h3 :class="headingClass">Still have questions?</h3>
    <p :class="paragraphClass">{{ paragraphText }}</p>
    <RouterLink to="/contact-us">
      <Button size="lg" class="py-6">
        {{ buttonText }}
      </Button>
    </RouterLink>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { Button } from '../ui/button';

const props = defineProps({
  page: {
    type: String,
    default: '',
  },
});

const isBusinessPage = computed(() => props.page === 'faqBusinessPage');
const containerClass = computed(() =>
  ['rounded-3xl py-12 px-6 text-center', isBusinessPage.value ? 'bg-grey-dark-900' : 'bg-grey-light-50'].join(' '),
);

const headingClass = computed(() =>
  ['font-semibold text-lg mt-6 mb-2', isBusinessPage.value ? 'text-white' : 'text-grey-light-900'].join(' '),
);

const paragraphClass = computed(() =>
  ['mb-6', isBusinessPage.value ? 'text-grey-light-400' : 'text-grey-light-600'].join(' '),
);

const paragraphText = computed(() =>
  isBusinessPage.value
    ? 'Get in touch with someone from our team who will be able to assist.'
    : "Can't find the answer you're looking for? Please chat to our friendly team.",
);

const buttonText = computed(() => (isBusinessPage.value ? 'Talk to Support' : 'Get in touch'));
</script>
